module.exports = ".paddingbottom10{\n    padding-bottom: 10px;\n}\n.paddingbottom20{\n    padding-bottom: 20px;\n}\n.paddingtop15{\n    padding-top: 15px;\n}\n.header-text{\n    font-family: 'Montserrat', sans-serif;\n      font-size: 20px;\n      color: #242829;\n  }\n.inputText{\n    font-family: 'Montserrat', sans-serif;\n      font-size: 14px;\n      color: #242829;\n  }\n.displayFlex{\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contact-us-dialog/contact-us-dialog.component.css
// module id = ./src/app/components/contact-us-dialog/contact-us-dialog.component.css
// module chunks = main